import React from "react";
import { PhoneMask, FieldMessage } from "Components";

export const PhoneField = ({
  onChange,
  field,
  value,
  error = {},
  ...props
}) => {
  const handleText = (value) => {
    onChange({ [field.name]: value });
  };

  return (
    <>
      <PhoneMask
        phoneNumber={value}
        onChange={(value) => handleText(value)}
        error={!!error.status}
        placeholder={field.placeholder ?? "Phone Number"}
        {...props}
      />
      <FieldMessage active={!!error.status} content={error.message} />
    </>
  );
};
